import React from 'react';
import { ICurrency, ICurrencyInput, Maybe } from '../../graphql/schema/p4types';

export type CurrencyContextType = {
  currency?: Maybe<ICurrency | ICurrencyInput>;
};

//Use to provide Currency information to child components (E.g. CurrencyInput).
const CurrencyContext = React.createContext({} as CurrencyContextType);
export default CurrencyContext;
